// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import store from 'store/dist/store.legacy.min';
import store from './store/index';
import axios from 'axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// Vue.use(store)
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/swiper.min.css';
import 'swiper/swiper.esm';
Vue.use(VueAwesomeSwiper);

/*引入iconfont图标*/
import './assets/iconfont/iconfont.css'

/*引入jq*/
import $ from 'jquery'
Vue.prototype.$jq=$

import vueToTop from 'vue-totop'
Vue.use(vueToTop)

//api接口
import api from "../src/assets/js/api/require/index";
Vue.prototype.$api = api;

//axios
Vue.prototype.$axios = axios;
// axios.defaults.baseURL = '/api'        //关键代码
Vue.config.productionTip = false;

//引入vue-resource
import VueResource from 'vue-resource'
Vue.use(VueResource)

// //引入im 即时通信
import tim from "./tim";
import TIM from 'tim-js-sdk'
import COSSDK from 'cos-js-sdk-v5'

window.tim = tim;
window.TIM = TIM;
Vue.prototype.$bus = new Vue(); // event Bus 用于无关系组件间的通信。
// Vue.prototype.$bus = $bus
Vue.prototype.tim = tim;
Vue.prototype.TIM = TIM;

let options = {
  SDKAppID: 1400194712 // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
};
// 创建 SDK 实例，TIM.create() 方法对于同一个 SDKAppID 只会返回同一份实例
TIM.create(options); // SDK 实例通常用 tim 表示
// 将腾讯云对象存储服务 SDK （以下简称 COS SDK）注册为插件，IM SDK 发送文件、图片等消息时，需要用到腾讯云的 COS 服务
tim.registerPlugin({'cos-wx-sdk': COSSDK})
tim.store = store
window.TIM = TIM
let $bus = new Vue()
Vue.prototype.TIM = TIM
Vue.prototype.$bus = $bus

import Cookies from "js-cookie";
Vue.use(Cookies)

//长链接
var klineServe = "";
if (window.location.protocol == "http:") {
  klineServe = "ws://47.107.110.127:8080";
} else {
  // klineServe = "wss://47.107.110.127:8080";
  klineServe = "wss://show26.vi5.cn";
}
Vue.prototype.klineServe = klineServe;
 
import { wxshare } from "../src/assets/js/wxShare";
Vue.use(wxshare);

// 引入layer
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';

Vue.prototype.$layer = layer(Vue);

Vue.prototype.toBack = function(val) {
  var path = sessionStorage.getItem("to") || "/";
  if (val && val != "" && typeof val == "string") {
    router.push({
      path: val,
    });
  } else if (path == "/") {
    router.push({
      path: path,
    });
  } else {
    router.go(-1);
  }
};

Vue.prototype.$h = (name) => {
  return name;
};

// import CryptoJS from "crypto-js"
// Vue.prototype.$CryptoJS = CryptoJS;

//密码RSA加密
import getCode from "../src/assets/js/createRsa";
Vue.prototype.$getCode = getCode;

//vue-lazyload
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad)

//vue_pageination
// import Pageination from 'vue_pageination';
// Vue.use(Pageination);

//通用函数
import fnc from "../src/assets/js/fnc/fnc.js";
Vue.prototype.$fnc = fnc;

/**/
// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(error=> error)
// }

//cookie
import {setCookie,getCookie,delCookie} from '@/assets/js/cookie'
Vue.prototype.$cookieStore = {setCookie,getCookie,delCookie}

import Meta from 'vue-meta';
// 使用vue-meta
Vue.use(Meta);

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.metaInfo){
    store.commit("CAHNGE_META_INFO", to.meta.metaInfo)
  }
  next()
})

// Vue.directive('title', {//单个修改标题
//   inserted: function (el, binding) {
//     document.title = el.dataset.title
//   }
// })

//vant
import {
  Row,
  Col,
  Cell,
  CellGroup,
  Lazyload,
  Dialog,
  Toast,
  Tab,
  Tabs,
  Popup,
  Uploader,
  Icon,
  NavBar,
  Button,
  DropdownMenu,
  DropdownItem,
  Search,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  NoticeBar,
  RadioGroup,
  Radio,
  NumberKeyboard,
  Switch,
  Rate,
} from "vant";
Vue.use(Row)
  .use(Col)
  .use(Cell)
  .use(CellGroup)
  .use(Dialog)
  .use(Toast)
  .use(Tab)
  .use(Tabs)
  .use(Popup)
  .use(Uploader)
  .use(Icon)
  .use(NavBar)
  .use(Button)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Search)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Swipe)
  .use(Lazyload)
  .use(SwipeItem)
  .use(NoticeBar)
  .use(RadioGroup)
  .use(Radio)
  .use(NumberKeyboard)
  .use(Switch)
  .use(Rate);



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  metaInfo(){
    return {
        title: this.$store.state.metaInfo.title,
        meta: [
            {
                name: "keywords",
                content: this.$store.state.metaInfo.keywords
            }, {
                name: "description",
                content: this.$store.state.metaInfo.description
            }
        ]
    }
  },
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js